import { Card, Col, Form, InputGroup, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import InputAddField from "../molecules/InputAddField";
import MobileAuth from "../molecules/MobileAuth";
import InputGroupValidation from "../molecules/InputGroupValidation";
import AddIp from "../molecules/AddIp";
import { addAutoHyphen } from "../../common/util";
import { useEffect, useState } from "react";
import { showAlert } from "../../../reducer/alertSlice";
import { useDispatch, useSelector } from "react-redux";

const BranchForm = ({defaultData, form, isDetail=false, isAddCompany=false}) => {
    const [data, setData] = useState({
        companyName: "",
        branchName: "",
        storeId: "",
        ownerName: "",
        branchTelArea: "",
        tel: "",
        registrationNo: "",
        registrationFilePath: "",
        registrationFileName: "",
        region: "",
        address: "",
        useIp: "1",
        contractFilePath: "",
        contractFileName: "",
        ipList: [],
        branchAdminList: [],
        generalAdminList: [],
        branchAdmin: [], // admin 정보까지 담겨있는 배열
        generalAdmin: [], // admin 정보까지 담겨있는 배열
        ...defaultData
    });

    const dispatch = useDispatch();
    const [useIp, setUseIp] = useState(data.useIp);
    const [ipList, setIpList] = useState([]);
    const [branchAdminList, setBranchAdminList] = useState([]);
    const [generalAdminList, setGeneralAdminList] = useState([]);
    const [companyNameList, setCompanyNameList] = useState([]);
    const areaOptions = useSelector(state => state.areaOptions);
    const loginInfo = useSelector(state => state.login);

    useEffect(() => {
        const companyNameArr = [];
        loginInfo.menuList.map(el => {
            companyNameArr.push({
                value: el.companyId,
                label: el.companyName
            })
        });
        setCompanyNameList(companyNameArr);

        setIpList([...ipList, ...data.ipList]);
        setBranchAdminList([...branchAdminList, ...data.branchAdminList]);
        setGeneralAdminList([...generalAdminList, ...data.generalAdminList]);
    },[]);
    
    // ip 사용 여부 수정 시
    useEffect(() => {
        form.setValue("useIp", useIp);
        if (form.watch("useIp") == 1) {
            setIpList([]);
        }
    },[useIp]);

    // ip 리스트 수정 시
    useEffect(() => {
        form.setValue("ipList", ipList);
        if (ipList.length > 0) {
            form.clearErrors("ipList");
        }
    },[ipList]);
    
    // 지점 관리자 수정 시
    useEffect(() => {
        form.setValue("branchAdminList", branchAdminList);
        if (branchAdminList.length > 0) {
            form.clearErrors("branchAdminList");
        }
    },[branchAdminList]);

    // 일반 관리자 수정 시
    useEffect(() => {
        form.setValue("generalAdminList", generalAdminList);
    },[generalAdminList]);
    
    // submit
    useEffect(() => {
        if (form.formState.isSubmitting) {
            const values = form.getValues();
            // 지점 관리자 등록 안했을 경우
            if (values.branchAdminList.length == 0) {
                form.setError("branchAdminList", {
                    type: "required"
                });
                dispatch(showAlert({
                    msg: "지점 관리자는 최소 1개 이상의 계정은 필수로 등록해야합니다."
                }))
                return;
            }
    
            if (useIp == 2) {
                // IP 등록 안했을 경우
                if (values.ipList.length == 0) {
                    form.setError("ipList", {
                        type: "required"
                    });
                    dispatch(showAlert({
                        msg: "IP를 등록해주세요."
                    }))
                    return;
                }
            }
        }
    },[form.formState.isSubmitting])

    useEffect(() => {
        setData({
            ...data,
            ...defaultData
        })
    },[defaultData]);

    const removeIpList = (value) => {
        setIpList(prev => prev.filter(val => value !== val))
    }
    const addIpList = (value) => {
        setIpList(prev => [...prev, value])
    }
    const removeBranchAdminList = (value) => {
        setBranchAdminList(prev => prev.filter(val => value !== val))
    }
    const addBranchAdminList = (value) => {
        setBranchAdminList(prev => [...prev, value])
    }
    const removeGeneralAdminList = (value) => {
        setGeneralAdminList(prev => prev.filter(val => value !== val))
    }
    const addGeneralAdminList = (value) => {
        setGeneralAdminList(prev => [...prev, value])
    }

    return (
        <>
            <Card className="mt-4">
                <Card.Header>
                    <Card.Title className="d-flex align-items-center gap-2 fs-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"/>
                        <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                        </svg>
                        지점 정보
                    </Card.Title>
                </Card.Header>

                <Card.Body>
                    {/* 업체명 */}
                    <Row>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    업체명 *
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroup>
                                        {
                                        !isDetail && !isAddCompany ? 
                                        <InputGroupValidation 
                                            setValue={(name, value) => form.setValue(name, value)}
                                            placeholder="업체명을 선택해주세요"
                                            type="select"
                                            register={form.register("companyId", {
                                                required: "업체명을 선택해주세요"
                                            })} 
                                            invalid={form.formState.errors['companyId']}
                                            data={companyNameList}
                                        >
                                        </InputGroupValidation>
                                        :
                                        <Form.Control disabled={true} defaultValue={data.companyName} />
                                        }
                                    </InputGroup>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* 지점명, Store ID */}
                    <Row>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3" controlId="formBranch">
                                <Form.Label column sm="2">
                                    지점명 *
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation
                                        defaultValue={data.branchName}
                                        register={form.register("branchName", {
                                            required: "지점명을 입력해주세요"
                                        })} 
                                        invalid={form.formState.errors['branchName']}
                                        placeholder="지점명을 입력하세요" />
                                </Col>
                            </Form.Group>
                        </Col>

                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3" controlId="formBranchID">
                                <Form.Label column sm="2">
                                    Store ID *
                                </Form.Label>
                                <Col>
                                    <InputGroupValidation 
                                        numAndScOnly={true}
                                        defaultValue={data.storeId}
                                        register={form.register("storeId", {
                                            required: "Store ID를 입력해주세요",
                                        })} 
                                        invalid={form.formState.errors['storeId']}
                                        placeholder="지점ID를 입력하세요" 
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* 대표자명, 전화번호 */}
                    <Row>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    대표자명
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation 
                                        defaultValue={data.ownerName}
                                        register={form.register("ownerName")} 
                                        placeholder="대표자명을 입력하세요" 
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    전화번호
                                </Form.Label>
                                <Col sm="9">
                                    <div className="d-flex gap-2 align-items-start">
                                        <div
                                            style={{width: "90px", minWidth: "80px"}}
                                        >
                                        <InputGroupValidation
                                            setValue={(name, value) => form.setValue(name, value)}
                                            type="select"
                                            invalid={form.formState.errors['branchTelArea']}
                                            register={form.register("branchTelArea")}
                                            defaultValue={data.tel ? data.tel.split("-")[0] : "02"}
                                            data={areaOptions.code}
                                        ></InputGroupValidation>
                                        </div>

                                        <InputGroupValidation 
                                            maxLength={9}
                                            defaultValue={data.tel ? (data.tel.split("-")[1] + "-" + data.tel.split("-")[2]) : ""}
                                            register={form.register("telNum")} 
                                            placeholder="-없이 숫자만 입력하세요" 
                                            onInput={(e) => {
                                                e.target.value = addAutoHyphen(e.target.value, true);
                                                
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* 사업자등록번호, 사업자등록증 */}
                    <Row>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    사업자등록번호
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation
                                        defaultValue={data.registrationNo}
                                        numAndScOnly={true}
                                        register={form.register("registrationNo")}
                                        placeholder="사업자등록번호를 입력하세요"
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    사업자등록증
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation 
                                        max={4}
                                        type="file"
                                        accept="image/jpg, image/png"
                                        path={data.registrationFilePath}
                                        defaultValue={data.registrationFileName}
                                        register={form.register("registrationFile")} 
                                        invalid={form.formState.errors['registrationFile']}
                                    />
                                    <div className="mt-2 small text-secondary">이미지(png/jpg) 파일로 등록해주세요</div>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* 지역, 상세주소 */}
                    <Row>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    지역
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation 
                                        type="select"
                                        setValue={(name, value) => form.setValue(name, value)}
                                        placeholder="지역을 선택해주세요"
                                        register={form.register("region")} 
                                        invalid={form.formState.errors['region']}
                                        data={areaOptions.options}
                                        defaultValue={data.region}
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    상세 주소
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation 
                                        type="textarea"
                                        register={form.register("address")} 
                                        invalid={form.formState.errors['address']}
                                        value={data.address}
                                        placeholder="주소를 입력해주세요"
                                        onInput={(e) => {
                                            setData({
                                                ...data,
                                                address: e.target.value
                                            })
                                        }} 
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* IP제한여부, 계약서 */}
                    <Row>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    IP 제한 여부 *
                                </Form.Label>
                                <Col sm="9">
                                    <div className="d-flex align-items-center">
                                        <InputGroupValidation type="radio" data={[{
                                                value: "1",
                                                label: "사용 안함",
                                            }, {
                                                value: "2",
                                                label: "제한 (등록된 IP에서만 로그인 가능)"
                                            }]}
                                            register={
                                                form.register("useIp")
                                            }
                                            checkedValue={useIp}
                                            onChange={(e) => {
                                                setUseIp(e.target.value);
                                            }}
                                        />
                                    </div>

                                    {
                                    (useIp == "2") &&
                                    <InputAddField
                                        btnText="IP 추가" 
                                        defaultCreated={data.ipList.length > 0 ? 0 : 1}
                                        handleDelete={removeIpList}
                                        confirm={<>삭제 시 해당 IP 주소에서 접속이 불가합니다.<br/>정말 해당 IP 주소를 삭제하시겠어요?</>}
                                        template={
                                            <AddIp 
                                                addedArr={ipList}
                                                addValue={addIpList}
                                                removeValue={removeIpList}
                                            />
                                        }
                                    >
                                        {
                                            // 이미 추가된 IP 리스트
                                            data.ipList &&
                                            data.ipList.map((el, idx) => {
                                                return (
                                                    <div key={"ipList_" + idx} val={el}></div>
                                                )
                                            })
                                        }
                                    </InputAddField>
                                    }
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs={6}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    계약서
                                </Form.Label>
                                <Col sm="9">
                                    <InputGroupValidation 
                                        register={form.register("contractFile")} 
                                        type="file"
                                        accept="image/jpg, image/png"
                                        defaultValue={data.contractFileName}
                                        path={data.contractFilePath}
                                    />
                                    <div className="mt-2 small text-secondary">이미지(png/jpg) 파일로 등록해주세요</div>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className="mt-4">
                <Card.Header>
                    <Card.Title className="d-flex align-items-center gap-2 fs-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                            <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                        </svg>
                        <span className="me-2">
                            지점 관리자
                        </span>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip style={{ fontSize: "12px", position: "fixed" }}>
                                    지점 관리자는 해당 지점 정보 수정 및
                                    <br/>관리자 계정 등록/삭제가 가능한 권한을 지닙니다.
                                </Tooltip>
                            }
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                            </svg>
                        </OverlayTrigger>

                        <span className="ms-2 fs-6 fw-normal text-danger">* 최소 1개 이상의 계정은 필수로 등록해야합니다.</span>
                    </Card.Title>
                </Card.Header>

                <Card.Body>
                    <Col xs={6}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="2">
                                휴대폰 번호(ID) *
                            </Form.Label>
                            <Col>
                                <InputAddField 
                                    btnText="계정 추가" 
                                    defaultCreated={data.branchAdmin.length > 0 ? 0 : 1} 
                                    confirm={<>계정 삭제 시 관리자 접속이 불가합니다. <br/>정말 해당 계정을 삭제하시겠어요?</>}
                                    handleDelete={removeBranchAdminList}
                                    template={<MobileAuth
                                                type="2"
                                                addedArr={branchAdminList}
                                                addValue={addBranchAdminList}
                                                removeValue={removeBranchAdminList}
                                            />} 
                                >
                                    {
                                        data.branchAdmin.length > 0 && 
                                        data.branchAdmin.map((el) => {
                                            return (
                                                <div val={el.phone} key={"branchAdmin_"+el.adminId}>
                                                    <div className="small text-secondary mt-2">최근 접속일시 | {el.lastLoginTime}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </InputAddField>
                            </Col>
                        </Form.Group>
                    </Col>
                </Card.Body>
            </Card>
            <Card className="mt-4">
                <Card.Header>
                    <Card.Title className="d-flex align-items-center gap-2 fs-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                            <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                        </svg>
                        <span className="me-2">
                            일반 관리자
                        </span>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip style={{ fontSize: "12px", position: "fixed" }}>
                                    일반 관리자는 리포트 관리 권한만 지닙니다.
                                </Tooltip>
                            }
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                            </svg>
                        </OverlayTrigger>
                    </Card.Title>
                </Card.Header>

                <Card.Body>
                    <Col xs={6}>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="2">
                                휴대폰 번호(ID)
                            </Form.Label>
                            <Col>
                            <InputAddField btnText="계정 추가" defaultCreated={data.generalAdmin.length > 0 ? 0 : 1} 
                                template={<MobileAuth
                                            type="2"
                                            addedArr={generalAdminList}
                                            addValue={addGeneralAdminList}
                                            removeValue={removeGeneralAdminList}
                                        />} 
                                confirm={<>계정 삭제 시 관리자 접속이 불가합니다. <br/>정말 해당 계정을 삭제하시겠어요?</>}
                                handleDelete={removeGeneralAdminList}
                            >
                                {
                                    data.generalAdmin.length > 0 && 
                                    data.generalAdmin.map((el) => {
                                        return (
                                            <div val={el.phone} key={el.id}>
                                                <div className="small text-secondary mt-2">최근 접속일시 | {el.lastLoginTime}</div>
                                            </div>
                                        )
                                    })
                                }
                            </InputAddField>
                            </Col>
                        </Form.Group>
                    </Col>
                </Card.Body>
            </Card>
        </>
    )
}

export default BranchForm;